module.exports = __webpack_public_path__ + "img/logo-intro.79e5193a.svg";